import React, { PureComponent } from 'react'
import {
    // @ts-ignore
    ShimmeredDetailsList, SelectionMode, DetailsListLayoutMode, ConstrainMode, Text, IColumn,
} from '@fluentui/react'
import history from 'helpers/history'
import { handleRenderColumn, onColumnClick } from 'helpers/methods/common'
import Status from 'types/status'
// @ts-ignore
// eslint-disable-next-line import/named
import { AppProps } from 'app'
import { Link } from 'react-router-dom'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import flattenObj from 'helpers/methods/flattenObj'
import Card from 'components/containers/card'
import styles from 'styles/pages/users/index.module.scss'
import { NEW_PATH } from 'types/others'
import User from 'requests/objects/user'

/** @debug {AppProps} */

/**
 * @augments {PureComponent<AppProps>} extends
 */
export default class IndexUsers extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {User[]} Items found in API */
            items: [],
            /** @type {User[]} Initial items found in API */
            iniItems: [],
        }
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.init()

        // this.search()
    }

    // /**
    //  * @inheritdoc
    //  * @param {object} prevProps Previous Props
    //  * @param {object} prevState Previous State
    //  */
    // componentDidUpdate(prevProps, prevState) {
    //     // this.init()

    //     // this.setupBreadcrumb()

    //     // this.setupCommandBar()

    //     // this.setState({
    //     //     columns: this.buildColumns(),
    //     // })
    // }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.usersHandlerGetAll?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb } = this.props

        setBreadcrumb([
            { text: 'Saisie utilisateur', key: 'user' },
            { text: 'Toutes les utilisateurs', key: 'all-user', isCurrentItem: true },
        ])
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const { setCommand } = this.props

        setCommand(
            [
                {
                    key: 'new',
                    text: 'Nouveau',
                    iconProps: { iconName: 'Add' },
                    onClick: () => history.push(`/users/${NEW_PATH}`),
                    disabled: false,
                },
            ],
        )
    }

    /**
     * Init Page
     */
    init() {
        const { setMessageBar, setCommand } = this.props

        setMessageBar({ isDisplayed: false })
        setCommand([])

        this.setupBreadcrumb()
        this.setupCommandBar()

        this.setState({ columns: this.buildColumns() }, () => this.search())
    }

    /**
     * Init <DetailList>
     * @returns {IColumn[]} Columns
     */
    // eslint-disable-next-line class-methods-use-this
    buildColumns() {
        return [
            {
                key: 'id',
                name: 'Id',
                fieldName: 'userId',
                minWidth: 50,
                maxWidth: 200,
                isResizable: true,
            },
            {
                key: 'profile',
                name: 'Profil',
                fieldName: 'profile',
                minWidth: 50,
                maxWidth: 200,
                isResizable: true,
                onRender: item => this.renderRole(item),
            },
            {
                key: 'email',
                name: 'Email',
                fieldName: 'email',
                minWidth: 50,
                maxWidth: 200,
                isResizable: true,
            },
        ]
    }

    /**
     * Search elements
     */
    search() {
        this.setState({
            status: Status.PENDING,
        }, async () => {
            const { usersHandler } = this.props
            try {
                this.usersHandlerGetAll = usersHandler.getAll()
                const users = await this.usersHandlerGetAll.fetch()
                this.setState({
                    items: users.map(x => this.flattenObj(x)),
                    iniItems: users,
                    status: Status.RESOLVED,
                })
            } catch (error) {
                switch (error?.constructor) {
                    case CancelRequestError:
                    case UnauthorizedError:
                    case InvalidEntityError: break
                    case NotImplementedError:
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                    default:
                        this.setState({
                            items: [],
                            iniItems: [],
                            status: Status.REJECTED,
                        })
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                }
            }
        })
    }

    /**
     * @param {User} item item
     * @returns {JSX.Element} Element
     */
    // eslint-disable-next-line class-methods-use-this
    renderRole(item) {
        const { param } = this.props

        return (<Text>{param.profiles.find(x => x.key === item.profileId).text}</Text>)
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            columns, status, items, iniItems,
        } = this.state

        return (
            <main className={styles.index}>
                <Card>
                    <ShimmeredDetailsList
                        items={items}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        onShouldVirtualize={() => true}
                        enableShimmer={status === Status.PENDING}
                        layoutMode={DetailsListLayoutMode.justified}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={(props, defaultRender) => defaultRender({ ...props, styles: { root: { paddingTop: 0 } } })}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        onRenderRow={(props, defaultRender) => (
                            <Link
                                to={{
                                    pathname: `/users/${props.item?.userId}`,
                                    state: {
                                        user: iniItems.find(x => x.userId === props.item?.userId),
                                    },
                                }}
                            >
                                {defaultRender(props)}
                            </Link>
                        )}

                    />
                    {!items?.length && [Status.RESOLVED, Status.REJECTED].includes(status)
                        && <Text styles={{ root: { fontStyle: 'italic', marginLeft: '1em' } }}>Aucun résultat trouvé</Text>}
                </Card>
            </main>
        )
    }
}

IndexUsers.prototype.onColumnClick = onColumnClick
IndexUsers.prototype.flattenObj = flattenObj
IndexUsers.prototype.handleRenderColumn = handleRenderColumn
